import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0293e82e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0293e82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0293e82e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0293e82e')) {
      api.createRecord('0293e82e', component.options)
    } else {
      api.reload('0293e82e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0293e82e&scoped=true&", function () {
      api.rerender('0293e82e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4PRIFhd3IBv0r/JS/comp/PopupBox.vue"
export default component.exports